import React, { useState, useEffect, useContext } from "react";
import Axios from "axios";
import InfoSection from "./InfoSection";
import TableSection from "./TableSection";
import { RegistrasiPeluangApi, AnalisaBarangJadiApi } from "api";
import { DataStatus } from "components";
import { RABContext } from "../RABContext";

const AnalisaBarangJadi = ({
  profit,
  processedData,
  dataBarangJadi,
  setDataBarangJadi,
  modalConfig,
  setModalConfig,
  action,
}) => {
  const { indexAnalisa } = useContext(RABContext);
  const [data, setData] = useState({});
  const [dataListAnalisa, setDataListAnalisa] = useState([]);
  const [dataGambar, setDataGambar] = useState([]);
  const [dataFile, setDataFile] = useState([]);
  const [dataSelect, setDataSelect] = useState([]);
  const [isFetch, setIsFetch] = useState({ loading: false, success: true });

  const mapAnalisa = (data) =>
    data?.map((item) =>
      Object({
        ...item,
        harga: item.harga,
      })
    );

  console.log(modalConfig);

  const getInitialData = () => {
    setIsFetch({ loading: true, success: true });
    const { id_item_atribut } = processedData;
    console.log(processedData);

    Axios.all([
      // action !== "CREATE"
      // ?
      // AnalisaBarangJadiApi.getAnalisaRAB({ id_item_atribut }),
      // :
      AnalisaBarangJadiApi.getAnalisaRAE({ id_item_atribut }),
      AnalisaBarangJadiApi.getDropdown(),
    ])
      .then(
        Axios.spread((analisa, dropdown) => {
          const dataAnalisa = analisa?.data?.data ?? {};
          console.log("wow", dataAnalisa);
          const mapDataListAnalisa = mapAnalisa(dataAnalisa?.analisa);
          const dataSelect = dropdown?.data?.data?.map((item) =>
            Object({
              ...item,
              value: item.id_item_buaso,
              label: `${item.kode_item} - ${item.nama_item}`,
            })
          );

          let gambar = [];
          let file = [];
          dataAnalisa?.files?.map((val) => {
            const generalFileType = val.path_gambar.split(".").pop();
            if (["jpg", "png", "gif", "jpeg"].includes(generalFileType)) {
              return gambar.push(val);
            }
            return file.push(val);
          });

          setData(dataAnalisa);
          setDataListAnalisa(mapDataListAnalisa);
          setDataGambar(gambar);
          setDataFile(file);
          setDataSelect(dataSelect);

          setIsFetch({ loading: false, success: true });
        })
      )
      .catch((err) => setIsFetch({ loading: false, success: false }));
  };

  useEffect(() => {
    getInitialData();
    return () => {};
  }, []);

  return (
    <>
      {isFetch.loading ? (
        <DataStatus loading={isFetch.loading} text="Memuat data ... " />
      ) : !isFetch.success && !isFetch.loading ? (
        <DataStatus text="Gagal memuat data!" />
      ) : (
        <>
          <InfoSection
            data={data}
            dataGambar={dataGambar}
            dataFile={dataFile}
          />

          <TableSection
            profit={profit}
            data={dataListAnalisa}
            dataSelect={dataSelect}
            dataBarangJadi={dataBarangJadi}
            setDataBarangJadi={setDataBarangJadi}
            modalConfig={modalConfig}
            setModalConfig={setModalConfig}
          />
        </>
      )}
    </>
  );
};

export default AnalisaBarangJadi;
